export default {
  500: 'internalServerError',
  502: 'badGateway',
  400: 'badRequest',
  401: 'unauthorized',
  403: 'forbidden',
  404: 'notFound'
}